// extracted by mini-css-extract-plugin
export var ModalTitle = "optimalBusinessModal-module--ModalTitle--1_ndJ";
export var ModalBody = "optimalBusinessModal-module--ModalBody--23oX_";